<template>
	<div>
		<portal to="tabs_nav">
			<v-tabs centered grow background-color="primary" dark v-model="Ntab">
				<v-tab
					@click="
						grupoUsar = academicos;
						changeTab('academico');
					"
					>ACADÉMICO</v-tab
				>
				<v-tab
					@click="
						grupoUsar = administrativos;
						changeTab('administrativo');
					"
					>ADMINISTRATIVO</v-tab
				>
				<v-tab
					@click="
						grupoUsar = ingenieria;
						changeTab('carrera');
					"
					>INGENIERÍA</v-tab
				>
			</v-tabs>
		</portal>

		<!-- CONTENIDO -->
		<v-tabs v-model="Ntab" :height="0">
			<v-tab-item>
				<anuncio-card :grupoUsar="academicos" :loading="loading"></anuncio-card>
			</v-tab-item>
			<v-tab-item>
				<anuncio-card :grupoUsar="administrativos" :loading="loading"></anuncio-card>
			</v-tab-item>
			<v-tab-item>
				<anuncio-card :grupoUsar="ingenieria" :loading="loading"></anuncio-card>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import store from "../store/index";
import AnuncioCard from "../components/AnuncioCard";
import { ANUNCIOS_API } from "../apiConfig";
import { getDataModule } from "../db_save";

export default {
	data: () => ({
		anuncios: [],
		Ntab: 0,
		grupoUsar: [],
		nothingToShow: false,
		loading: true,
		academicos: [],
		administrativos: [],
		ingenieria: []
	}),
	components: {
		AnuncioCard
	},
	methods: {
		clasificarAnuncios(anuncios) {
			anuncios.forEach(anuncio => {
				switch (anuncio.categoria) {
					case "Academico":
						this.academicos.unshift(anuncio);
						break;

					case "Administrativo":
						this.administrativos.unshift(anuncio);
						break;

					case "Ingenieria":
						this.ingenieria.unshift(anuncio);
						break;
				}
			});
		},
		getAnuncios() {
			//console.log("Get Eventos ", ANUNCIOS_API);

			getDataModule("anuncios", 1000 * 60 * 10, ANUNCIOS_API)
				.then(anuncios => {
					//console.log("Anuncios: ", anuncios);
					if (anuncios.length > 0) {
						this.anuncios = anuncios;
						this.clasificarAnuncios(anuncios);
					} else {
						this.anuncios = [];
						this.nothingToShow = true;
					}
				})
				.catch(e => {
					console.error("Error ", e);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		changeTab(name) {
			this.$ua.trackEvent(`Anuncios`, "CategoriaChange", name);
		}
	},
	created() {
		store.commit("toggleTabs", true);
		this.getAnuncios();
	}
};
</script>

<style>
#acciones {
	justify-content: space-around;
}
</style>
